<template>
  <div class="case-viewer-header-title px-0">
    <div v-if="!isEditing" class="row">
      <h1
        class="case-viewer-header-title__title col-11 display-3"
        @dblclick="triggerLabelInput()"
      >
        {{ title }}
      </h1>
      <div v-if="!isEditing && editable" class="edit-title col-1">
        <font-awesome-icon
          class="modify-icon ml-2 mb-1"
          :icon="['fad', 'pen']"
          @click="triggerLabelInput()"
        />
      </div>
    </div>

    <div v-else class="row">
      <input
        v-autowidth="{
          maxWidth: '700px',
          minWidth: '300px',
          comfortZone: 0,
        }"
        class="case-viewer-header-title__title case-viewer-header-title__title--input col-11 display-3"
        placeholder="Nom de la collection"
        ref="newLabelEdition"
        v-model="newTitle"
        @blur="updateTitle()"
        @keyup.enter="$event.target.blur()"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'case-viewer-header-title',
  props: {
    title: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isEditing: false,
      newTitle: '',
    };
  },
  methods: {
    triggerLabelInput() {
      this.newTitle = this.title;
      this.isEditing = true;
      this.$nextTick(() => this.$refs.newLabelEdition.focus());
    },
    updateTitle() {
      if (this.newTitle !== this.title) {
        this.$emit('update-title', this.newTitle);
      }
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.case-viewer-header-title__title {
  margin-bottom: 8px;
  line-height: 1.2;
}

.case-viewer-header-title__title--input:focus {
  outline: none;
  border: none;
}

.edit-title {
  visibility: hidden;
  margin-top: auto;
  margin-bottom: auto;
}

.case-viewer-header-title:hover .edit-title {
  visibility: visible;
}

.modify-icon {
  max-width: 20px;
  cursor: pointer;
  color: $grey-5-mayday;
  padding: 2px;
  &:hover {
    border-radius: 3px;
    background-color: #e9ecef;
    color: $blue-mayday;

    &.delete {
      color: $red-mayday;
    }
  }
}
</style>
